import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage } from "../../elements";
import { gtag } from "../../utils";
import "./style.scss";
import Swiper from 'swiper';
const BrandTechnology = props => {
	const { rendering, fields, page } = props;
	const isAR = page?.fields?.rtl?.value;
  const { title, subtitle, description, list, hideTitle } = fields;
  const swiperEl = useRef(null)
  const swiper = useRef(null)
  const rediusEl = useRef(null)
  const rootNode = useRef(null)
  const listEl = useRef(null)
  const contentEl = useRef(null)
  const isMobile = mobileIs()
  const [currentIndex, setCurrentIndex] = useState(0);

  const buildSwiper = () => {
    const options = {
      watchSlidesProgress: true,
      slidesPerView: 1,
      spaceBetween: 120,
      on: {
        slideChange(swiper) {
          let realIndex = swiper.realIndex
          setCurrentIndex(realIndex)
        }
      }
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  const changeIndex = (e, index) => {
    gtag('event', 'Component_info', {
      'component_name': 'BrandTechnology',
      'page_title': page?.name
    });
  	setCurrentIndex(index)
  	swiper.current.slideTo(index, 500, false)
  }

  const onResize = () => {
  	let listHeight = listEl.current.getBoundingClientRect().height;
  	let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
  	if (!isMobile) {
  	  let timerM = setTimeout((v) => {
  	    clearTimeout(timerM)
				if(!hideTitle.value) {
					rediusEl.current.style.transform = 'translateY(300px)';
					listEl.current.style.top = pageHeight - 60 + 'px';
					contentEl.current.style.top = listHeight * -1 + 'px';
				}
  	    swiperEl.current.style.transform = 'scale(1)';
  	  }, 500)
  	} else {
  	  let timerP = setTimeout((v) => {
  	    clearTimeout(timerP)
				if(!hideTitle.value) {
					rediusEl.current.style.transform = 'translateY(500px)';
					listEl.current.style.transform = 'translateY(0)';
					contentEl.current.style.transform = 'translateY(0)';
				}
  	  }, 500)
  	}
  }

  useEffect(() => {
  	let listHeight = listEl.current.getBoundingClientRect().height;
  	let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
  	if (!isMobile) {
      let timerM = setTimeout((v) => {
        clearTimeout(timerM)
				if(!hideTitle.value) {
					rediusEl.current.style.transform = 'translateY(300px)';
					listEl.current.style.top = pageHeight - 60 + 'px';
					contentEl.current.style.top = listHeight * -1 + 'px';
				}
        swiperEl.current.style.transform = 'scale(1)';
      }, 500)
  	} else {
      let timerP = setTimeout((v) => {
        clearTimeout(timerP)
				if(!hideTitle.value) {
					rediusEl.current.style.transform = 'translateY(500px)';rediusEl.current.style.transform = 'translateY(500px)';
					listEl.current.style.transform = 'translateY(0)';
					contentEl.current.style.transform = 'translateY(0)';
				}
      }, 500)
  	}
  	if (!isMobile) {
  		buildSwiper()
  	}
  	window.addEventListener("resize", onResize);
  	return () => {
  		window.removeEventListener("resize", onResize);
  	}
  }, [])

  const rootClasses = classNames("c-brand-technology", isAR ? 'rtl' : '', hideTitle?.value ? 'hideTitle' : '', getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
    	{!hideTitle?.value && <div className="c-brand-technology__content" ref={contentEl}>
    		<RichText className={'c-brand-technology__content__title'} tag="div" field={title} />
    		<RichText className={'c-brand-technology__content__subtitle'} tag="div" field={subtitle} />
    		<RichText className={'c-brand-technology__content__description'} tag="div" field={description} />
    	</div>}
    	<div className="c-brand-technology__list" ref={listEl}>
    		<div className="c-brand-technology__list__content" ref={swiperEl}>
	    		<div className="swiper-wrapper">
	    			{list.map((item, index) => (
		          <div className={"c-brand-technology__list__item swiper-slide"} key={item.id}>
		          	<BackgroundImage {...item?.fields?.mobileImage} className={"c-brand-technology__list__item__mobileimage"}>
		          		<RichText className={'c-brand-technology__list__item__title'} tag="div" field={item?.fields?.title} />
		          	</BackgroundImage>
		          	<BackgroundImage {...item?.fields?.pcImage} className={"c-brand-technology__list__item__pcimage"} />
		          	<RichText className={'c-brand-technology__list__item__description'} tag="div" field={item?.fields?.description} />
		          </div>
		        ))}
	        </div>
        </div>
    	</div>
    	<div className="c-brand-technology__text">
    		<div className="c-brand-technology__text__content">
	    		{list.map((item, index) => (
	    			<div className={classNames("c-brand-technology__text__item", currentIndex === index ? 'active' : '')} key={item.id} onClick={(e) => changeIndex(e, index)}>
	    				<RichText className={'c-brand-technology__text__item__title'} tag="div" field={item?.fields?.title} />
	    				<RichText className={'c-brand-technology__text__item__description'} tag="div" field={item?.fields?.description} />
	    			</div>
	    		))}
    		</div>
    	</div>
			<div className="c-brand-technology__redius" ref={rediusEl}></div>
    </div>
  );
};

export default 	BrandTechnology;